import(/* webpackMode: "eager", webpackExports: ["PageFeedback"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\components\\PageFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SafetyAlertBuilder"] */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\components\\tools\\SafetyAlertBuilder.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\graha\\source\\repos\\product-factory\\products\\01-rams\\web\\node_modules\\next\\dist\\client\\app-dir\\link.js");
